import React, { useState, useEffect } from "react";
import { Modal } from "./Modal";
import coin from "../assets/images/coin.png";
import { Api } from "../Service/api";
import { ACTIONS } from "../redux/actions";
import { useDispatch } from "react-redux";
import { ErrorToast, SuccessToast } from "./Toast";
import moment from "moment";
import { handlePayment } from "../helper";
// import { Coin } from 'lucide-react'

const SubjectPurchase = ({
  isModelOpen,
  setIsPurchaseModelOpen,
  selectedDrpData,
  onPaymentSuccess,
}) => {
  const dispatch = useDispatch();

  //   const [modalOpen, setModalOpen] = useState(isModelOpen)
  const [promoCode, setPromoCode] = useState("");
  const [expiredDate, setExpiredDate] = useState("");
  const [promoCodeDetails, setPromoCodeDetails] = useState("");
  const [purchaseDetails, setPurchaseDetails] = useState({
    standard: 10,
    semester: "Yearly",
    subject: "English",
    expiryDate: "30-04-2024",
    // promoApplied: {
    //   name: 'Vande15',
    //   discount: 15,
    //   amount: 45,
    // },
    totalPrice: 300,
  });

  const GetInfo = async () => {
    dispatch(ACTIONS.startLoading());
    try {
      let body = {
        standard: selectedDrpData?.standard?.id,
        semester: selectedDrpData?.semester?.id,
        subject: selectedDrpData?.subject?.id,
      };
      const { data } = await Api.GetPriceForSpecificSubject(body);
      const res = JSON.parse(data);
      if (res?.status === 200) {
        setPurchaseDetails(res?.data);
        setExpiredDate(res?.expiryDate[0]?.expiryDate);
      } else {
        ErrorToast(res?.message);
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  useEffect(() => {
    if (selectedDrpData?.subject?.id) {
      GetInfo();
    }
  }, [selectedDrpData?.subject?.id]);

  // useEffect(() => {
  //   if (expiredDate && isModelOpen) {
  //     const expiredDateCheck = moment(expiredDate);
  //         const currentDate = moment();

  //       if (!expiredDateCheck.isSameOrBefore(currentDate)) {
  //         ErrorToast("Subscription Expired");
  //         handleModelClose();
  //       }
  //   }
  // }, [expiredDate])

  //   useEffect(() => {
  //     setIsPurchaseModelOpen(isModelOpen)
  //   }, [isModelOpen])

  const handleModelClose = () => {
    setIsPurchaseModelOpen(false);
  };

  const handleModelApply = async () => {
    dispatch(ACTIONS.startLoading());
    try {
      const params = {
        price: purchaseDetails?.price,
        subscriptionPriceId: purchaseDetails?.id,
        promocode: promoCodeDetails?.id || null,
        usedcoins: 0,
      };

      const { data } = await Api.CreateSubscription(JSON.stringify(params));
      const resspo = JSON.parse(data);
      if (resspo?.razorpayOrderId) {
        const paymentResponse = await handlePayment(
          {
            ...resspo,
          },
          `Board:${selectedDrpData?.board?.board_name}, Medium:${selectedDrpData?.medium?.name}, Standard:${selectedDrpData?.standard.name}, Semester:${selectedDrpData?.semester.semester}, Subject:${selectedDrpData?.subject.subject}`
        );

        const { data } = await Api.PaymentSuccess(
          JSON.stringify(paymentResponse)
        );
        const res = JSON.parse(data);
        if (res?.status === 200) {
          SuccessToast("Payment Success");
          handleModelClose();
          onPaymentSuccess();
        }
        dispatch(ACTIONS.stopLoading());
      } else {
        //  ErrorToast(res?.message);
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }

    // setIsPurchaseModelOpen(false);
    // Add your purchase logic here
  };

  const handleApplyPromo = async () => {
    dispatch(ACTIONS.startLoading());
    try {
      let body = {
        promocode: promoCode,
      };
      const { data } = await Api.GetPromocode(body);
      const res = JSON.parse(data);
      if (res?.status === 200) {
        SuccessToast("Promo Code Applied");
        setPromoCodeDetails(res?.data);
      } else {
        // ErrorToast(res?.message);
        setPromoCodeDetails(null);
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
    // You would typically make an API call here to validate the promo code
    // and update the purchase details and total price accordingly
  };

  const TotalAmount = () => {
    return Number(
      purchaseDetails?.price -
      (promoCodeDetails
        ? purchaseDetails?.price *
        (Number(promoCodeDetails?.discountValue).toFixed(0) / 100)
        : 0)
    );
  };

  return (
    <div>
      <Modal
        title="Confirmation"
        buttonText="Buy Now"
        width="max-w-2xl"
        disabled={false}
        modalOpen={isModelOpen}
        onApply={handleModelApply}
        onClose={handleModelClose}
      >
        <div>
          <h2 className="text-xl font-semibold mb-4">Purchase Details</h2>
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <div className="grid grid-cols-2 gap-2">
              <div>Standard</div>
              <div className="text-right">
                {selectedDrpData?.standard?.name}
              </div>
              <div>Semester</div>
              <div className="text-right">
                {selectedDrpData?.semester?.semester}
              </div>
              <div>Subject</div>
              <div className="text-right">
                {selectedDrpData?.subject?.subject}
              </div>
              <div>Expiry Date</div>
              <div className="text-right">
                {moment(expiredDate).format("DD-MM-YYYY")}
              </div>
              {promoCodeDetails?.name && (
                <>
                  <div>Promo Applied ({promoCodeDetails?.name})</div>
                  <div className="text-right text-green-600">
                    <span className="text-red-500 text-xs">
                      -{Number(promoCodeDetails?.discountValue).toFixed(0)}%
                    </span>{" "}
                    ₹
                    {Number(
                      (purchaseDetails?.price *
                        Number(promoCodeDetails?.discountValue).toFixed(0)) /
                      100
                    ).toFixed(0)}
                  </div>
                </>
              )}
            </div>
          </div>

          <h2 className="text-xl font-semibold mb-4">Apply Promocode</h2>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center mb-6">
            <input
              type="text"
              placeholder="Have a Promo Code?"
              className="flex-grow border rounded-t-lg sm:rounded-l-lg sm:rounded-tr-none px-4 py-2 mb-2 sm:mb-0 focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
            />
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded-b-lg sm:rounded-r-lg sm:rounded-bl-none hover:bg-blue-600 transition-colors"
              onClick={handleApplyPromo}
            >
              Apply Promocode
            </button>
          </div>

          <div className="flex flex-col items-center">
            {/* <Coin className="w-16 h-16 text-yellow-500 mb-2" /> */}
            <img
              src={coin}
              alt="Promo Code"
              className="w-24 h-24 object-cover rounded-lg"
            />
            <div className="text-sm text-gray-600 mb-1">
              Total you have to pay
            </div>
            <div className="text-3xl font-bold">
              ₹ {TotalAmount()}
              <span className="text-xl ml-1 line-through font-normal text-gray-500">
                {purchaseDetails?.withoutDiscountPrice}
              </span>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SubjectPurchase;
